// shim so that we don't have to import react - esBuild currently doesn't do this by default
// We use this as per https://esbuild.github.io/content-types/#auto-import-for-jsx
// See https://github.com/evanw/esbuild/issues/334 for more details
import * as React from 'react';
export { React };
